import { Plus } from 'lucide-react'

import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import { Button, TabsList, TabsTrigger } from '@fortem-monorepo/react-ui'

import { CanAccess } from '@/components/CanAccess'
import { PERMISSIONS } from '@/constants/permissions'
import { useMarketSummaryActions } from '@/pages/instruments/market-summary/market-summary-actions'
import { MARKET_SUMMARY_TABS, useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummaryTabsProps {}

export const MarketSummaryTabs: React.FC<MarketSummaryTabsProps> = ({}) => {
  const { viewsQuery, tab } = useMarketSummaryContext()
  const { createEvent, addInstrument } = useMarketSummaryActions()

  return (
    <HeaderConfigBar>
      <div className="flex items-center gap-2">
        <TabsList>
          <TabsTrigger value={MARKET_SUMMARY_TABS.DISPLAYS} disabled={!viewsQuery.data}>
            Displays
          </TabsTrigger>
          <TabsTrigger value={MARKET_SUMMARY_TABS.INSTRUMENTS} disabled={!viewsQuery.data}>
            Instruments
          </TabsTrigger>
          <TabsTrigger value={MARKET_SUMMARY_TABS.EVENTS} disabled={!viewsQuery.data}>
            Events
          </TabsTrigger>
        </TabsList>
        <CanAccess permissions={[PERMISSIONS.WRITE_MARKET_SUMMARY]}>
          {tab === MARKET_SUMMARY_TABS.INSTRUMENTS && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => {
                addInstrument()
              }}
            >
              Add new instrument <Plus />
            </Button>
          )}
          {tab === MARKET_SUMMARY_TABS.EVENTS && (
            <Button size="sm" variant="outline" onClick={() => createEvent()}>
              Add new event <Plus />
            </Button>
          )}
        </CanAccess>
      </div>
    </HeaderConfigBar>
  )
}
